"use client";

import { ChakraProvider } from "@chakra-ui/react";
import { ColorModeProvider } from "./color-mode";
import { styles } from "../../theme";
import { Toaster } from "./toaster";

export function Provider(props) {
    return (
        <ChakraProvider value={styles}>
            <ColorModeProvider {...props} />
            <Toaster />
        </ChakraProvider>
    );
}
